<div class="relative flex items-center gap-2 px-5 py-2">
  @if (user()) {
    <app-avatar [user]="user()" />

    <div class="flex grow flex-col">
      <span [appTruncate]="100" class="text-lg leading-6">
        {{ name() }}
      </span>
      <span [appTruncate]="150" class="text-xs leading-[14px] text-text-2">
        {{ email() || shopifyId() }}
      </span>
    </div>
  }

  <button mat-icon-button data-cy="user-menu-trigger" [matMenuTriggerFor]="menu">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <!-- eslint-disable-next-line -->
  <div (click)="$event.stopPropagation()">
    @if (!isAdmin()) {
      <button mat-menu-item [routerLink]="billPath">
        <mat-icon>credit_card</mat-icon>

        <span>{{ 'common.billing' | translate }}</span>
      </button>
      <!-- <app-button -->
      <!--   mainClass="h-10 px-3 py-0 w-full" -->
      <!--   [routerLink]="billPath" -->
      <!--   textAlign="left" -->
      <!-- > -->
      <!--   <ng-icon name="featherDollarSign" class="mr-4" size="20" /> -->
      <!--   <span class="text-15 leading-[20px]"> Billing </span> -->
      <!-- </app-button> -->
    }

    <button mat-menu-item [routerLink]="settingPath">
      <mat-icon>settings</mat-icon>

      <span>{{ 'common.settings' | translate }}</span>
    </button>

    @if (isAdmin()) {
      <mat-divider />

      <button mat-menu-item data-cy="log-out-btn" (click)="onLogout()">{{ 'common.log-out' | translate }}</button>
    }
  </div>
</mat-menu>
